// removed by extract-text-webpack-plugin
module.exports = {"remove-element":"remove-element__remove-element___3FtaB","removeElement":"remove-element__remove-element___3FtaB"};


//////////////////
// WEBPACK FOOTER
// ../stylesheet/css/header-builder/remove-element.css
// module id = 536
// module chunks = 0